<template>
  <CContainer class="pt-5" fluid>
    <CRow>
      <CCol class="col-7">
        <h3 class="pl-3 mb-0 pb-0">System Configuration</h3>
        <b-breadcrumb class="my-0 pt-1" style="border-bottom: 0px">
          <b-breadcrumb-item active>
            <CIcon name="cil-settings" />
            System Configuration
          </b-breadcrumb-item>
          <b-breadcrumb-item>
            Principal
          </b-breadcrumb-item>
        </b-breadcrumb>
      </CCol>
      <CCol class="col-5">
        <CButton color="primary" class="float-right mt-2" @click="showCreateModal">
          Create <FaIcon icon="plus" />
        </CButton>
      </CCol>
    </CRow>
    <CCard class="custom-card" v-if="$helper.isRole($availRoles['FIMS']) || $helper.isRole($availRoles['HO'])">
      <CCardBody class="px-0 pb-0">
        <CRow>
          <CCol class="ml-5">
            <CForm>
              <b-input-group>
                <b-input-group-prepend>
                  <b-form-select v-model="table.filterType" :options="table.filterOptions" @change="onChangeFilterType"></b-form-select>
                </b-input-group-prepend>
                <b-input-group-prepend>
                  <b-form-select v-if="table.filterType == 'transType'" v-model="table.filterValue" :options="table.filterValueTransTypeOptions" style="min-width: 206.5px;"></b-form-select>
                  <b-form-input maxlength="50" v-else-if="table.filterType == 'id'" type="text" placeholder="Search" v-model="table.filterValue" onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"></b-form-input>
                  <b-form-input 
                    maxlength="19" 
                    v-else 
                    @input="table.filterValue = $event.toString().replace(/\./g, '')"
                    type="text" placeholder="Search" 
                    :value="$helper.thousandSeparator(table.filterValue)"
                    onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                  ></b-form-input>
                </b-input-group-prepend>
                <b-input-group-append>
                  <CButton size="sm" color="primary" style="color: white;" class="btn-icon mr-2 custom-button-action" type="submit" @click="filterTable">
                    <CIcon name="cil-magnifying-glass" />
                  </CButton>
                </b-input-group-append>
              </b-input-group>
            </CForm>
          </CCol>
        </CRow>
        <CRow class="mt-4" v-if="$helper.isRole($availRoles['HO'])">
          <CCol>
            <b-table striped hover show-empty
              responsive="xl"
              :items="table.items"
              :fields="table.fields"
              :busy="!table.isLoaded"
              no-local-sorting no-sort-reset
              @sort-changed="onSortChanged"
            >
              <template slot="empty">
                <div v-if="!table.isLoaded" class="text-center">
                  <b-spinner label="Fetching Data..."></b-spinner>
                </div> 
                <div v-else class="text-center">
                  Tidak ada data
                </div> 
              </template>
              <template #cell(transType)="row">
                <span v-if="row.value == 'F'">Fiducia</span>
                <span v-else-if="row.value == 'A'">APHT</span>
                <span v-else-if="row.value == 'R'">Roya</span>
              </template>
              <template #cell(minValue)="row">
                {{ Number(row.value).toLocaleString('id') }}
              </template>
              <template #cell(pnbpInvoice)="row">
                {{ Number(row.value).toLocaleString('id') }}
              </template>
              <template #cell(action)="row">
                <CButton size="sm" color="warning" style="color: white;" @click="showEditModal(row.item.id, row.item.transType, row.item.minValue, row.item.pnbpInvoice)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-pencil" />
                </CButton> 
                <CButton size="sm" color="danger" style="color: white;" @click="showDeleteModal(row.item.id, row.item.transType, row.item.minValue, row.item.pnbpInvoice)" class="btn-icon mr-2 custom-button-action">
                  <CIcon name="cil-trash" />
                </CButton> 
              </template>
            </b-table>
            <CCardFooter>
              <PageSizer :totalRows="table.totalRows" :page="table.currentPage" :options="tablePageOptions" @limit-change="onLimitChange" @page-change="onPageChange" />
            </CCardFooter>
          </CCol>
        </CRow>
      </CCardBody>
    </CCard>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>

    <CModal :closeOnBackdrop="false" :show.sync="showDeletePrincipalModal" :centered="true">
      <div slot="header"><h5>Konfirmasi Delete Principal</h5></div>
      <div class="body">
        <CRow class="mb-2">
          <CCol>
            Apakah Anda yakin ingin menghapus Principal berikut?
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            ID
          </CCol>
          <CCol md="8" sm="7">
            : {{ deletePrincipal.id }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Tipe Transaksi
          </CCol>
          <CCol md="8" sm="7">
            : <span v-if="deletePrincipal.transType == 'F'">Fiducia</span><span v-else-if="deletePrincipal.transType == 'A'">APHT</span><span v-else-if="deletePrincipal.transType == 'R'">Roya</span>
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            Minimal Value
          </CCol>
          <CCol md="8" sm="7">
            : Rp {{ Number(deletePrincipal.minValue).toLocaleString('id') }}
          </CCol>
        </CRow>
        <CRow>
          <CCol md="4" sm="5">
            PNBP Value
          </CCol>
          <CCol md="8" sm="7">
            : Rp {{ Number(deletePrincipal.pnbpInvoice).toLocaleString('id') }}
          </CCol>
        </CRow>
      </div>
      <div slot="footer">
        <CButton color="primary" @click="showDeletePrincipalModal = false">Batal</CButton>
        <CButton class="ml-2" color="danger" @click="confirmDeletePrincipal" :disabled="isLoading.deletePrincipal">
          <b-spinner small type="grow" v-if="isLoading.deletePrincipal" /> 
          {{ isLoading.deletePrincipal ? 'Sedang diproses...' : 'Ya' }}
        </CButton>
      </div>
    </CModal>

    <CForm>
      <CModal :closeOnBackdrop="false" :show.sync="showCreateEditModal" :centered="true">
        <div slot="header"><h5>{{ principalAction == 'create' ? 'Create' : 'Edit' }} Principal</h5></div>
        <div class="body">
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Tipe Transaksi"
                label-for="principal-transType"
                :state="principal.transType.isValid"
              >
                <multiselect 
                  v-model="principal.transType.value" 
                  :options="principal.transType.options" 
                  :state="principal.transType.isValid"
                  :class="{custom_multiselect_invalid: principal.transType.isValid === false}"
                  id="principal-transType"
                  placeholder="Select an option"
                  :showLabels="false"
                  openDirection="bottom"
                  label="text"
                  track-by="value"
                >
                  <template slot="singleLabel" slot-scope="props">{{ props.option.text }}</template>
                  <template slot="option" slot-scope="props">{{ props.option.text }}</template>
                  <template slot="noResult">No elements found.</template>
                </multiselect>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="Minimum Value"
                label-for="principal-minValue"
                :state="principal.minValue.isValid"
              >
                <b-form-input
                  :value="$helper.thousandSeparator(principal.minValue.value)"
                  :state="principal.minValue.isValid"
                  placeholder="Minimum Value"
                  id="principal-minValue"
                  @input="principal.minValue.value = $event.toString().replace(/\./g, '')"
                  maxlength="19"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
          <CRow class="mb-2">
            <CCol sm="12">
              <b-form-group
                invalid-feedback="This input is required."
                label="PNBP Value"
                label-for="principal-pnbpInvoice"
                :state="principal.pnbpInvoice.isValid"
              >
                <b-form-input
                  :value="$helper.thousandSeparator(principal.pnbpInvoice.value)"
                  :state="principal.pnbpInvoice.isValid"
                  placeholder="PNBP Value"
                  id="principal-pnbpInvoice"
                  @input="principal.pnbpInvoice.value = $event.toString().replace(/\./g, '')"
                  maxlength="19"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 13"
                ></b-form-input>
              </b-form-group>
            </CCol>
          </CRow>
        </div>
        <div slot="footer">
          <CButton color="primary" variant="outline" @click="showCreateEditModal = false">Cancel</CButton> 
          <CButton v-if="principalAction == 'create'" class="ml-2" color="primary" type="submit" @click="createItem" :disabled="isLoading.createItem">
            <b-spinner small type="grow" v-if="isLoading.createItem" /> 
            {{ isLoading.createItem ? 'Loading...' : 'Save' }}
          </CButton>
          <CButton v-else class="ml-2" color="primary" type="submit" @click="editItem" :disabled="isLoading.editItem">
            <b-spinner small type="grow" v-if="isLoading.editItem" /> 
            {{ isLoading.editItem ? 'Loading...' : 'Save' }}
          </CButton>
        </div>
      </CModal>
    </CForm>

    <CModal
      color="primary"
      :show.sync="showErrorModal" :centered="true" :closeOnBackdrop="false">
      <div slot="header"><h5>{{errorTitle}}</h5></div>
      <div class="body">
        {{errorLabel}}
      </div>
      <div slot="footer">
        <CButton v-if="errorLogout" color="primary" @click="$router.push({name: 'Login'})">Login</CButton>
        <CButton v-else color="primary" @click="showErrorModal = false">OK</CButton>
      </div>
    </CModal>
  </CContainer>
</template>

<script>
export default {
  name: 'ConfigPrincipalList',
  data() {
    return {
      showErrorModal: false,
      errorLogout: false,
      errorLabel: 'Unexpected Error',
      errorTitle: 'Error!',
      tablePageOptions: [
        { value: 10, text: '10'},
        { value: 20, text: '20'},
        { value: 30, text: '30'},
        { value: 40, text: '40'},
        { value: 50, text: '50'}
      ],
      table: {
        isLoaded: false,
        fields: [
          {key: "id", label: "ID", sortable: true},
          {key: "transType", label: "Tipe Transaksi", sortable: true},
          {key: "minValue", label: "Minimal Value (Rp)", sortable: true},
          {key: "pnbpInvoice", label: "PNBP Value (Rp)", sortable: true},
          {key: "action", label: "Aksi", sortable: false}
        ],

        items: [],

        filterType: "id",
        filterOptions: [
          { value: "id", text: "ID" },
          { value: "transType", text: "Tipe Transaksi" },
          { value: "minValue", text: "Minimal Value" },
          { value: "pnbpInvoice", text: "PNBP Value" }
        ],
        filterValue: "",
        filterValueTransTypeOptions: [
          { value: "F", text: "Fiducia" },
          { value: "A", text: "APHT" },
          { value: "R", text: "Roya" },
        ],

        sort: {
          by: null,
          desc: false
        },

        currentPage: 1,
        perPage: 10,
        totalRows: 0,
        totalPages: 0
      },

      isLoading: {
        deletePrincipal: false,
        editItem: false,
        createItem: false,
      },

      showDeletePrincipalModal: false,
      deletePrincipal: {
        id: 0,
        transType: "F",
        minValue: 0,
        pnbpInvoice: 0
      },

      showCreateEditModal: false,
      selectedPrincipalId: 0,
      principalAction: 'create',
      principal: {
        minValue: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "minValue"
        },
        pnbpInvoice: {
          value: '',
          isValid: null,
          isRequired: true,
          payloadKey: "pnbpInvoice"
        },
        transType: {
          value: { value: "F", text: "Fiducia" },
          isValid: null,
          isRequired: true,
          options: [
            { value: "F", text: "Fiducia" },
            { value: "A", text: "APHT" },
            { value: "R", text: "Roya" }
          ],
          payloadKey: "transType"
        },
      }
    }
  },
  methods: {

    filterTable(event) {
      event.preventDefault()

      this.getTableItems(this.table.currentPage)
    },

    // thousandSeparated(field) {
    //   let temp = ''
      
    //   switch(field) {
    //     case 'minValue':
    //       temp = this.principal.minValue.value
    //       break
    //     case 'pnbpInvoice':
    //       temp = this.principal.pnbpInvoice.value
    //       break
    //     case 'filter':
    //       temp = this.table.filterValue
    //       break
    //   }

    //   if (this.$helper.isEmpty(temp)) return

    //   temp = temp.toString().replace(/\./g, "")
    //   temp = this.$helper.thousandSeparator(temp)

    //   switch(field) {
    //     case 'minValue':
    //       this.principal.minValue.value = temp
    //       break
    //     case 'pnbpInvoice':
    //       this.principal.pnbpInvoice.value = temp
    //       break
    //     case 'filter':
    //       this.table.filterValue = temp
    //       break
    //   }

    //   this.$forceUpdate()
    // },

    editItem(event) {
      event.preventDefault()

      this.isLoading.editItem = true
      let isFormValid = true
      let obj = {
        id: this.selectedPrincipalId
      }
      for(const [key, data] of Object.entries(this.principal)){
        if (key == 'transType') {
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
        } else{
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = this.$helper.normalizedNumber(data.value)
          }
        }
      }

      if (isFormValid) {
        let postUrl = '/principalRange/edit/'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.showCreateEditModal = false
              this.resetInputFields()
              this.getTableItems(this.table.currentPage)
              this.$helper.toastSuccess(this, "Edit Principal Berhasil! " + (response.data.reason ? response.data.reason : ""))
            } else{
              this.$helper.toastError(this, "Edit Principal Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Edit Principal Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Edit Principal Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isLoading.editItem = false
          })
        }
      } else{
        this.isLoading.editItem = false
      }
    },

    createItem(event) {
      event.preventDefault()

      this.isLoading.createItem = true
      let isFormValid = true
      let obj = {}
      for(const [key, data] of Object.entries(this.principal)){
        if (key == 'transType') {
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = data.value.value
          }
        } else{
          // The rest of the field
          if (data.isRequired && this.$helper.isEmpty(data.value)) {
            isFormValid = false
            data.isValid = false
          } else{
            data.isValid = null
            obj[data.payloadKey] = this.$helper.normalizedNumber(data.value)
          }
        }
      }

      if (isFormValid) {
        let postUrl = '/principalRange/add/'
        // only send axios request if role is valid
        if(this.$helper.isRole(this.$availRoles['HO'])){
          this.isSubmitting = true
          this.$axios.post(postUrl, obj).then(response => {
            if(response.status == 200){
              this.resetInputFields()
              this.getTableItems(this.table.currentPage)
              this.$helper.toastSuccess(this, "Create Principal Berhasil! " + (response.data.reason ? response.data.reason : ""))
              this.showCreateEditModal = false
            } else{
              this.$helper.toastError(this, "Create Principal Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
            }
          })
          .catch(error => {
            if(!this.$helper.isEmpty(error.response)){
              this.$helper.toastError(this, "Create Principal Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
            }
            else{
              this.$helper.toastError(this, "Create Principal Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
            }
          })
          .finally(() => {
            this.isLoading.createItem = false
          })
        }
      } else{
        this.isLoading.createItem = false
      }
    },

    resetInputFields() {
      this.principal.minValue.value = null
      this.principal.pnbpInvoice.value = null
      this.principal.transType.value = null

      this.principal.minValue.isValid = null
      this.principal.pnbpInvoice.isValid = null
      this.principal.transType.isValid = null
    },

    showCreateModal() {
      this.resetInputFields()

      this.showCreateEditModal = true
      this.principalAction = 'create'
    },

    showEditModal(id, transType, minValue, pnbpInvoice) {
      this.resetInputFields()

      this.selectedPrincipalId = id
      this.principal.transType.value = this.principal.transType.options.filter(obj => obj.value == transType)[0]
      this.principal.minValue.value = minValue
      this.principal.pnbpInvoice.value = pnbpInvoice

      this.principalAction = 'edit'
      
      this.showCreateEditModal = true
    },

    showDeleteModal(id, transType, minValue, pnbpInvoice) {
      this.deletePrincipal.id = id
      this.deletePrincipal.transType = transType
      this.deletePrincipal.minValue = minValue
      this.deletePrincipal.pnbpInvoice = pnbpInvoice

      this.showDeletePrincipalModal = true
    },

    confirmDeletePrincipal() {
      this.isLoading.deletePrincipal = true
      let processUrl = "/principalRange/delete";
      let data = new FormData();
      data.set('id', this.deletePrincipal.id);
      this.$axios.post(processUrl, data).then((response) => {
        if (response.status === 200){
          this.$helper.toastSuccess(this, "Delete Principal sukses!")
          this.showDeletePrincipalModal = false
        } else {
          this.$helper.toastError(this, "Delete Principal Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "Delete Principal Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "Delete Principal Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.isLoading.deletePrincipal = false

        if(this.$helper.isRole(this.$availRoles['HO'])){
          this.getTableItems(this.table.currentPage)
        }
      })
    },
  
    onSortChanged(ctx) {
      this.table.sort.by = ctx.sortBy
      this.table.sort.desc = ctx.sortDesc
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems(this.table.currentPage)
      }
    },

    onChangeFilterType() {
      if (this.table.filterType == "transType") {
        this.table.filterValue = "F"
      } else{
        this.table.filterValue = null
      }
    },

    onLimitChange(newPerPage) {
      this.table.perPage = newPerPage
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems()
      }
    },
  
    onPageChange(newPage) {
      // only fetch data when roles apply
      if(this.$helper.isRole(this.$availRoles['HO'])){
        this.getTableItems(newPage)
      }
    },

    getTableItems(page = 1) {
      this.table.isLoaded = false
      this.table.items = []
      if(isNaN(page)) {
        this.table.currentPage = 1
      }
      else {
        this.table.currentPage = page
      }
      // URL builder
      let getUrl = "/principalRange/getAll"
      
      let params = this.$helper.getBasePagedQuery(this.table.currentPage - 1, this.table.perPage)
      if(!this.$helper.isEmpty(this.table.filterValue)) {
        params['filterType'] = this.table.filterType
        params['filterValue'] = ((this.table.filterType == 'id' || this.table.filterType == 'transType') ? this.table.filterValue : this.$helper.normalizedNumber(this.table.filterValue))
      }
      if(this.table.sort.by != null) {
        params = this.$helper.getBaseSortQuery(this.table.sort, params)
      }
      
      return this.$axios.get(getUrl, {params: params}).then(response => {
        if(response.status == 200){
          sessionStorage.setItem("filterConfigPrincipalType", this.table.filterType)
          sessionStorage.setItem("filterConfigPrincipalValue", this.table.filterValue)
          this.table.items = response.data.data.data
          this.table.totalRows = response.data.data.totalElements
          this.table.totalPages = response.data.data.totalPages
        }
        else{
          // this.errorAction(response)
          this.$helper.toastError(this, "List Principal Gagal! " + (response.data.reason ? response.data.reason : "Unknown Error"))
        }
      })
      .catch(error => {
        // this.errorAction(error)
        if(!this.$helper.isEmpty(error.response)){
          this.$helper.toastError(this, "List Principal Gagal! " +  (!this.$helper.isEmpty(error.response.data.reason) ? error.response.data.reason : 'Endpoint Not Found'))
        }
        else{
          this.$helper.toastError(this, "List Principal Gagal! " + (!this.$helper.isEmpty(error.message) ? error.message : "Network Error"))
        }
      })
      .finally(() => {
        this.table.isLoaded = true
      })
    },
  
    errorAction(error){
      let listError = this.$helper.errorHandling(error);
      this.errorTitle = this.$errorLabel.generic;
      this.errorLabel = 'Terjadi kesalahan: '+listError[0] || 'Unknown Error';
      if (this.errorLabel.toLowerCase().includes('token expired')){
        this.errorLogout = true;
      }
      this.showErrorModal = true;
    },

  },

  created(){
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterConfigPrincipalType"))){
      this.table.filterType = sessionStorage.getItem("filterConfigPrincipalType")
    }
    if(!this.$helper.isEmpty(sessionStorage.getItem("filterConfigPrincipalValue"))){
      this.table.filterValue = sessionStorage.getItem("filterConfigPrincipalValue")
    }
    this.getTableItems()
  },
}
</script>

<style scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>